import { Colors } from "assets/colors";
import { styles as inputStyles } from "common/inputStyles";

export const styles: any = {
  container: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "40vw",
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: "max-content",
    overflowY: "auto",
    borderRadius: "5px",
    p: 3
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: Colors.GrayText,
    marginBottom: "1rem",
    "& svg": {
      cursor: "pointer"
    }
  },
  subHeader: {
    color: Colors.BlackText,
    fontSize: ".875rem",
    margin: "1.5rem 0 1rem 0"
  },
  textfield: {
    paddingTop: "8px",
    paddingBottom:"8px"
  },
  subText: {
    color: Colors.BlackText,
    fontSize: ".875rem",
  },
  input: {
    ...inputStyles.inputLight,
    marginBottom: 0,
  },
  textarea: {
    ...inputStyles.inputLight,
    height: "70px",
    width: "100%",
    margin: 0
  },
  inputContainer: {
    paddingTop: ".5rem !important"
  },
  label: {
    fontSize: ".87rem",
    color: Colors.BlueText,
    margin: 0
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "1.5rem 0 0 0"
  },
  cancelButton: {
    ...inputStyles.buttonGreenOutline,
    padding: ".3rem 1.5rem",
    marginRight: ".5rem"
  },
  addButton: {
    ...inputStyles.buttonGreen,
    padding: ".3rem 1.5rem",
  },

  deleteButton:{
    ...inputStyles.buttonOrange,
    padding: ".3rem 1.5rem",
    marginRight: ".5rem"
  },
  subContainer: {
    marginBottom: "1rem"
  },
  error: {
    fontSize: ".7rem",
    color: Colors.Red,
    padding: 0,
    margin: 0
  }
}
